import React from 'react';
import '../App.css';

const Hero = () => (
  <section className="Hero">
    <div className="Hero-container">
      <h1 className="gradient-text">kellee martins</h1>
      <h2>Frontend Engineer</h2>
    </div>
  </section>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js